import type {PageRouteConfig} from '@router';

import PinBuyPackage from 'modules/Services/PromotionCenter/Pin/BuyPackage/PinBuyPackage';

export function createPromotionCenterPinBuyPackageRoute(): PageRouteConfig {
  return {
    element: <PinBuyPackage />,
    layout: {
      title: 'خرید بسته',
      hasNavigate: false,
      hasHeader: true,
      hasBack: true,
      hasLeftIcon: false,
      link: -1
    }
  };
}
